import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../constants";
import { ENDPOINTS } from "../../config";

export interface TokenResponse {
  access?: string;
  refresh?: string;
  access_token?: string;
  refresh_token?: string;
  token?: string;
}

export const useAuthToken = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (credentials: {
      username?: string;
      user?: string;
      email?: string;
      password: string;
    }): Promise<TokenResponse> => {
      const username = credentials.username ?? credentials.user ?? credentials.email ?? "";

      const resp = await fetchClient<TokenResponse>(ENDPOINTS.auth, {
        method: "POST",
        body: { username, password: credentials.password },
      });

      if (resp.error || !resp.data) {
        const msg =
          resp.error?.detail ??
          resp.error?.message ??
          JSON.stringify(resp.error) ??
          `Auth failed (${resp.status})`;
        throw new Error(msg);
      }

      return resp.data;
    },
    onSuccess: (data) => {
      const access = data.access ?? data.access_token ?? data.token;
      const refresh = data.refresh ?? data.refresh_token;

      if (access) localStorage.setItem(ACCESS_TOKEN, access);
      if (refresh) localStorage.setItem(REFRESH_TOKEN, refresh);

      qc.invalidateQueries({ queryKey: ["current-user"] });
      qc.refetchQueries({ queryKey: ["current-user"] });
    },
  });
};

export default useAuthToken;
